import React from 'react';

const ClaudeCodeLeak = () => (
  <article className="news-article-body">
    <p className="news-lead">
      On March 31, 2026, Anthropic accidentally shipped its entire Claude Code codebase inside
      a public npm package — exposing over 512,000 lines of TypeScript, internal system prompts,
      and 44 unreleased feature flags. This was the second time the same packaging error occurred;
      the first incident happened in February 2025 and went largely unnoticed.
    </p>

    <h2>How the Leak Happened</h2>
    <p>
      Security researcher Chaofan Shou discovered that <code>claude-code@2.1.88</code> was shipped
      with a 59.8 MB <strong>source map</strong> file inside the npm package. Source maps are
      normally used in development to map minified JavaScript back to original source — they should
      never be included in production builds. The error allowed anyone to download and read the
      complete TypeScript source directly from npm's public CDN.
    </p>
    <p>
      Within hours, the codebase was mirrored across GitHub, accumulating tens of thousands of stars
      and forks before Anthropic could respond.
    </p>

    <h2>What Was Exposed</h2>
    <ul>
      <li><strong>1,900+ TypeScript files</strong> across the entire project</li>
      <li>Every <strong>internal system prompt</strong> and AI instruction</li>
      <li><strong>44 compile-time feature flags</strong> for unreleased capabilities</li>
      <li>Multi-agent orchestration logic and ~40 internal tools</li>
      <li>An unreleased <strong>"autoDream"</strong> background agent that can read session transcripts</li>
      <li>An <strong>"Undercover Mode"</strong> that strips AI attribution from Anthropic employees' OSS contributions</li>
    </ul>

    <h2>Why It Matters</h2>
    <p>
      The Claude Code tool has broad access to users' local machines — file systems, terminals,
      git repositories, and IDE bridges. The leak revealed that the scope of system access is
      wider than most users assumed, reigniting debates about the appropriate level of disclosure
      for AI coding agent capabilities.
    </p>
    <p>
      For security practitioners, the incident highlights a growing risk in the AI toolchain era:
      production npm packages may carry developer artifacts — source maps, internal configs,
      or unstripped symbols — that expose proprietary IP and attack surfaces.
    </p>

    <h2>Anthropic's Response</h2>
    <p>
      Anthropic attributed the incident to <em>"human error in release packaging"</em> rather than
      a deliberate breach. The company pulled the affected npm version and issued a patched release.
      No user data was accessed; the exposure was of Anthropic's own internal code.
    </p>

    <div className="news-insight-box">
      <h3>Key Takeaway</h3>
      <p>
        Always strip source maps from production builds. For AI agentic tools specifically,
        transparency about system access scope should be proactive — not discovered through leaks.
      </p>
    </div>
  </article>
);

export default ClaudeCodeLeak;
